document.addEventListener('DOMContentLoaded', function() {
    var DURATION = 4500;
    var TAB_CLASS = 'tab';
    var autoRotation;
    var startRotation = function startRotation() {
        autoRotation = setInterval(activateNextTab, DURATION);
    };
    var stopRotation = function stopRotation() {
        clearInterval(autoRotation);
    };
    var activateTab = function activateTab(tab) {
        var tabs = document.querySelectorAll(`.${TAB_CLASS}`);
        var index = Array.from(tabs).indexOf(tab);
        tabs.forEach(function(t) {
            return t.classList.remove('active');
        });
        tabs[index].classList.add('active');
        $(tabs[index]).trigger('click');
    };
    var activateNextTab = function activateNextTab() {
        var tabs = document.querySelectorAll(`.${TAB_CLASS}`);
        var activeTab = document.querySelector(`.${TAB_CLASS}.active`);
        var activeIndex = Array.from(tabs).indexOf(activeTab);
        var nextIndex = (activeIndex + 1) % tabs.length;
        activateTab(tabs[nextIndex]);
    };
    var tabMouseEnterHandler = function tabMouseEnterHandler(event) {
        var tab = event.target;
        stopRotation();
        activateTab(tab);
    };
    var tabMouseLeaveHandler = function tabMouseLeaveHandler() {
        startRotation();
    };
    var isSpecificDivVisible = function isSpecificDivVisible() {
        var specificDiv = document.querySelector('.section_showcase');
        return specificDiv && window.getComputedStyle(specificDiv).display !== 'none';
    };
    if (isSpecificDivVisible()) {
        var tabs = document.getElementsByClassName(TAB_CLASS);
        Array.from(tabs).forEach(function(tab) {
            tab.addEventListener('mouseenter', tabMouseEnterHandler);
            tab.addEventListener('mouseleave', tabMouseLeaveHandler);
        });
        startRotation();
        var addClickListenerById = function addClickListenerById(id, url) {
            var tab = document.getElementById(id);
            if (tab) tab.addEventListener('click', function() {
                activateTab(tab);
                window.location.href = url;
            });
        };
        addClickListenerById('tab-1', '/features/receipt-scanner.html');
        addClickListenerById('tab-2', '/features/expense-management.html');
        addClickListenerById('tab-3', '/features/mileage-tracker.html');
    }
});

//# sourceMappingURL=leaky-faucet-repair-cost-result.cd6810ca.js.map
